app.factory("ProgramService", ["$http", "$log",
    function ($http) {
        var ProgramService = {};

        ProgramService.list = function (params) {
            return $http.get("/program/list", {
                params: {
                    query: params.query,
                    page: params.page || 1,
                    faculty: params.faculty,
                    level: params.level,
                    limit: params.limit || 10,
                    availableForSelection: params.selectionState
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        ProgramService.listForHead = function (params) {
            return $http.get("/lecturer/program/list", {
                params: {
                    query: params.query,
                    page: params.page || 1,
                    faculty: params.faculty,
                    level: params.level,
                    limit: params.limit || 10,
                    availableForSelection: params.selectionState
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        ProgramService.isActive = function () {
            return $http.get("/program/isActive", {
            }).then(function (resp) {
                return resp;
            });
        };

        ProgramService.getStudentSubjects = function (params) {
            return $http.get("/program/student/" + params.studentId).then(function (resp) {
                return resp.data;
            });
        };

        ProgramService.search = function (params) {
            return $http.get("/program/search", {params: {name: params.name}})
                .then(function (resp) {
                    return resp.data;
                });
        };

        ProgramService.create = function (params) {
            var data = {
                code: params.code,
                name: params.name,
                speciality: params.speciality,
                faculty: params.faculty,
                semesters: params.semesters,
                level: params.level,
                credits: params.credits
            };

            return $http.post("/program/create", data).then(function () {
                return true;
            });
        };

        ProgramService.update = function (params) {
            return $http.post("/program/update", {
                _id: params._id,
                code: params.code,
                name: params.name,
                speciality: params.speciality,
                faculty: params.faculty,
                semesters: params.semesters,
                level: params.level,
                credits: params.credits,
                availableForSelection: params.availableForSelection,
                heads: params.heads,
                attachment: params.attachment,
            }).then(function () {
                return true;
            });
        };

        ProgramService.copyProgram = function (params) {
            return $http.post("/program/copy", {
                programId: params.programId,
                migration: params.migration,
                code: params.code
            }).then(function () {
                return true;
            }).catch(function (err) {
                console.error(err);
            });
        };

        ProgramService.fetchOne = function (programId) {
            return $http.get("/program/" + programId).then(function (resp) {
                return resp.data;
            });
        };

        ProgramService.fetchList = function (programIds) {
            programIds = typeof programIds === 'string' ? [programIds] : programIds;
            return $http.post("/program/listByIds", {programIds:programIds}).then(function (resp) {
                return resp.data;
            });
        };

        ProgramService.fetchContainersByProgram = function (programId) {
            return $http.get("/program/container/list", {
                params: {
                    programId: programId
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        ProgramService.createContainer = function (params) {
            return $http.post("/program/container/add", {
                type: params.type,
                name: params.name,
                parent: params.parent,
                program: params.program,
                required: params.required
            }).then(function (resp) {
                return resp.data;
            });
        };

        ProgramService.fetchContainer = function (params) {
            return $http.get("/container/one/" + params.containerId).then(function (resp) {
                return resp.data;
            });
        };

        ProgramService.updateContainer = function (params) {
            return $http.post("/container/update", {
                "_id": params._id,
                "name": params.name,
                "required": params.required
            }).then(function (resp) {
                return resp.data;
            });
        };

        ProgramService.removeContainer = function (params) {
            return $http.post("/container/remove", {
                "containerId": params.containerId
            }).then(function (resp) {
                return resp.data;
            });
        };

        ProgramService.createSubjectWrapper = function (params) {
            return $http.post("/container/subject/add", {
                subject: params.subjectId,
                lecturer: params.lecturerId,
                container: params.containerId,
                season: params.season,
                semester: params.semester,
                credits: params.credits,
                preCredits: params.preCredits,
                name: params.name,
                program: params.program,
                prerequisites: params.prerequisites,
                equals: params.equals
            }).then(function (resp) {
                return resp.data;
            });
        };

        ProgramService.editSubjectWrapper = function (params) {
            return $http.post("/container/subject/update", {
                _id: params._id,
                name: params.name,
                subject: params.subjectId,
                lecturer: params.lecturerId,
                container: params.containerId,
                season: params.season,
                semester: params.semester,
                program: params.program,
                credits: params.credits,
                preCredits: params.preCredits,
                prerequisites: params.prerequisites,
                equals: params.equals
            }).then(function (resp) {
                return resp.data;
            });
        };

        ProgramService.deleteSubjectWrapper = function (params) {
            return $http.post("/container/subject/remove", {
                "subjectWrapperId": params.wrapperId
            }).then(function (resp) {
                return resp.data;
            });
        };

        ProgramService.removeProgram = function (programId) {
            return $http.post("/program/remove", {
                "id": programId
            }).then(function (resp) {
                return resp.data;
            });
        };

        ProgramService.blockProgram = function (programId, action) {
            return $http.post("/program/block", {
                "id": programId,
                "action": action
            }).then(function (resp) {
                return resp.data;
            });
        };

        ProgramService.activeForRegisterList = function (params) {
            return $http.get("/program/register/list", {
                params: {
                    query: params.query,
                    page: params.page || 1,
                    faculty: params.faculty,
                    level: params.level,
                    limit: params.limit || 10,
                    availableForRegister: params.selectionState
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        ProgramService.activateForRegister = function (programId) {
            return $http.post("/program/register/activate", {
                "programId": programId
            }).then(function (resp) {
                return resp.data;
            });
        };

        ProgramService.deactivateForRegister = function (programId) {
            return $http.post("/program/register/deactivate", {
                "programId": programId
            }).then(function (resp) {
                return resp.data;
            });
        };

        ProgramService.deactivateAllForRegister = function () {
            return $http.post("/program/register/deactivateAll").then(function (resp) {
                return resp.data;
            });
        };

        return ProgramService;
    }
]);
